import { render, staticRenderFns } from "./shareAlert.vue?vue&type=template&id=9212c370&scoped=true&"
import script from "./shareAlert.vue?vue&type=script&lang=js&"
export * from "./shareAlert.vue?vue&type=script&lang=js&"
import style0 from "./shareAlert.vue?vue&type=style&index=0&id=9212c370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9212c370",
  null
  
)

component.options.__file = "shareAlert.vue"
export default component.exports